/** @jsxImportSource @emotion/react */
import React, { FC, PropsWithChildren } from 'react';
import {
  Box,
  Button,
  CircularProgress,
  css,
  Grow,
  Slide,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';
import { MAIN_BUTTON_HEIGHT } from 'config/constants';
import { Props } from './types';

const MainButton: FC<PropsWithChildren<Props>> = ({
  visible = false,
  loading,
  children,
  ...props
}) => {
  const theme = useTheme();

  return (
    <>
      <Slide in={visible} direction="up">
        <Box
          css={css`
            position: fixed;
            left: 0;
            right: 0;
            bottom: 0;
            width: 100%;
          `}
          style={{
            zIndex: theme.zIndex.appBar,
            background: theme.palette.background.default,
            paddingBottom: visible
              ? 'var(--tg-safe-area-inset-bottom, 0px)'
              : '0px',
          }}
        >
          <Grow in={visible}>
            <Button
              variant="contained"
              color="primary"
              size="large"
              fullWidth
              css={css`
                min-height: ${MAIN_BUTTON_HEIGHT}px;
              `}
              {...props}
            >
              <Stack direction="row" alignItems="center" spacing={1.5}>
                <Typography component="span" fontWeight={500}>
                  {children}
                </Typography>

                {loading && <CircularProgress color="inherit" size={20} />}
              </Stack>
            </Button>
          </Grow>
        </Box>
      </Slide>

      <Box
        css={css`
          transition: padding 100ms ease;
        `}
        style={{
          paddingBottom: visible
            ? `calc(${MAIN_BUTTON_HEIGHT}px + var(--tg-safe-area-inset-bottom, 0px))`
            : 0,
        }}
      />
    </>
  );
};

export default MainButton;
